import React, {useState} from 'react'
import {Accordion, Col, Row} from 'react-bootstrap'
import {escapeRegExp} from 'lodash'

import Section from '../../components/Section'
import faqData from './FAQ.data.json'
import * as styles from './FAQ.module.scss'
import './FAQ.scss'

const FAQ: React.FC = () => {
  const [search, setSearch] = useState<string>('')
  const searchRegExp = new RegExp(search)

  const filteredQuestions = faqData.filter(
    ({question, answer}) =>
      search.length === 0 ||
      searchRegExp.test(question) ||
      searchRegExp.test(answer),
  )

  const getHighlightedText = (text: string) => {
    const parts = text.split(new RegExp(`(${escapeRegExp(search)})`, 'gi'))

    if (search.length < 1) return text

    return parts
      .map((part) =>
        part.toLowerCase() === search.toLowerCase()
          ? `<span class="${styles.highlighted}">${part}</span>`
          : `<span>${part}</span>`,
      )
      .join('')
  }

  // This function renders odd or even questions
  const renderQuestions = (nth: 'odd' | 'even'): React.ReactNode => {
    const condition = (i: number) => (nth === 'odd' ? i % 2 !== 0 : i % 2 === 0)

    return filteredQuestions.map(
      ({question, answer}, i) =>
        condition(i) && (
          <Accordion key={question} className="mb-3">
            <Accordion.Item eventKey="0">
              <Accordion.Header className={styles.questionStyle}>
                <span
                  dangerouslySetInnerHTML={{
                    __html: getHighlightedText(question),
                  }}
                />
              </Accordion.Header>

              <Accordion.Body className={styles.answerStyle}>
                <span
                  dangerouslySetInnerHTML={{__html: getHighlightedText(answer)}}
                />
              </Accordion.Body>
            </Accordion.Item>
          </Accordion>
        ),
    )
  }

  return (
    <Section id="faq" background="gray" className="text-center">
      <h2 className="fs-1 fw-bold mb-4 mb-lg-5">Frequently asked questions</h2>
      <input
        type="text"
        className={styles.search}
        title="Type your keywords here"
        placeholder="Type your keywords here"
        onChange={(e) => setSearch(e.currentTarget.value)}
      />

      <p className="mt-4 my-lg-5 fs-5 fw-semibold">
        {filteredQuestions.length > 0
          ? 'Below are some answers to the most commonly asked questions about chickenpox:'
          : 'Sorry, nothing seems to match that search term.'}
      </p>

      <Row className="mt-5 gx-3">
        {/* Questions are rendering in two columns due to collapse / expand functionality */}

        <Col md={6}>{renderQuestions('even')}</Col>
        <Col md={6}>{renderQuestions('odd')}</Col>
      </Row>
    </Section>
  )
}

export default FAQ
